import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="simulation"
export default class extends Controller {
  static targets = ["unitCount", "totalAmount", "fundGross", "fundTax", "fundNet", "bankGross", "bankTax", "bankNet"]
  static values = { unitAmount: Number, returnRate: Number, bankRate: { type: Number, default: 0.2 }, taxRate: { type: Number, default: 20.42 } }

  connect() {
    this.calculate()
  }

  selectAll(event) {
    event.target.select()
  }

  calculate() {
    const units = parseInt(this.unitCountTarget.value, 10) || 0
    const investment = units * this.unitAmountValue

    this.totalAmountTarget.textContent = investment.toLocaleString()

    const fundGross = Math.floor(investment * this.returnRateValue / 100)
    const bankGross = Math.floor(investment * this.bankRateValue / 100)
    const fundTax = Math.floor(fundGross * this.taxRateValue / 100)
    const bankTax = Math.floor(bankGross * this.taxRateValue / 100)

    this.fundGrossTarget.textContent = `¥${fundGross.toLocaleString()}`
    this.fundTaxTarget.textContent = `¥${fundTax.toLocaleString()}`
    this.fundNetTarget.textContent = `¥${(fundGross - fundTax).toLocaleString()}`
    this.bankGrossTarget.textContent = `¥${bankGross.toLocaleString()}`
    this.bankTaxTarget.textContent = `¥${bankTax.toLocaleString()}`
    this.bankNetTarget.textContent = `¥${(bankGross - bankTax).toLocaleString()}`
  }
}
